
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/12-days-of-neat",
      function () {
        return require("private-next-pages/12-days-of-neat.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/12-days-of-neat"])
      });
    }
  